import { useState } from 'react';

interface UseConfirmationModalReturn {
    showModal: boolean;
    modalProps: {
        title: string;
        message: string;
        onConfirm: () => void;
        onCancel: () => void;
    };
    confirmAction: (config: {
        title: string;
        message: string;
        onConfirm: () => void;
    }) => void;
    closeModal: () => void;
}

const useConfirmationModal = (): UseConfirmationModalReturn => {
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [onConfirmCallback, setOnConfirmCallback] = useState<() => void>(() => () => { });

    const confirmAction = ({ title, message, onConfirm }: { title: string; message: string; onConfirm: () => void }) => {
        setTitle(title);
        setMessage(message);
        setOnConfirmCallback(() => onConfirm);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const modalProps = {
        title,
        message,
        onConfirm: () => {
            onConfirmCallback();
            closeModal();
        },
        onCancel: closeModal,
    };

    return { showModal, modalProps, confirmAction, closeModal };
};

export default useConfirmationModal;
